// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".relocate_legend[data-v-267c25f0]{position:absolute;bottom:-60px}", ""]);
// Exports
module.exports = exports;
